{
	"name": "@iqai/adk-cli",
	"version": "0.2.6",
	"description": "CLI tool for creating, running, and testing ADK agents",
	"main": "dist/index.js",
	"types": "dist/index.d.ts",
	"bin": {
		"adk": "./dist/index.mjs"
	},
	"scripts": {
		"build": "tsup",
		"dev": "tsup --watch",
		"test": "vitest run",
		"test:watch": "vitest"
	},
	"repository": {
		"type": "git",
		"url": "https://github.com/IQAIcom/adk-ts.git",
		"directory": "packages/adk-cli"
	},
	"keywords": [
		"ai",
		"llm",
		"agent",
		"cli",
		"adk",
		"typescript"
	],
	"author": "IQAI",
	"license": "MIT",
	"dependencies": {
		"@clack/prompts": "^0.11.0",
		"@hono/node-server": "^1.18.1",
		"@iqai/adk": "workspace:*",
		"chalk": "^5.4.1",
		"commander": "^12.1.0",
		"dedent": "^1.6.0",
		"giget": "^2.0.0",
		"hono": "^4.6.13",
		"marked": "^14.1.3",
		"marked-terminal": "^7.2.1",
		"esbuild": "^0.23.0"
	},
	"devDependencies": {
		"@iqai/tsconfig": "workspace:*",
		"@types/marked-terminal": "^6.1.1",
		"@types/node": "^20.17.30",
		"tsup": "^8.4.0",
		"typescript": "^5.3.2",
		"vitest": "^3.1.3"
	},
	"packageManager": "pnpm@9.0.0",
	"engines": {
		"node": ">=22.0"
	},
	"files": [
		"dist",
		"!**/*.test.*",
		"!**/*.json",
		"CHANGELOG.md",
		"LICENSE",
		"README.md"
	],
	"publishConfig": {
		"access": "public"
	}
}
